import { render, staticRenderFns } from "./ContractLayoutComponent.vue?vue&type=template&id=64448816&scoped=true&"
import script from "./ContractLayoutComponent.vue?vue&type=script&lang=js&"
export * from "./ContractLayoutComponent.vue?vue&type=script&lang=js&"
import style0 from "./ContractLayoutComponent.vue?vue&type=style&index=0&id=64448816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64448816",
  null
  
)

export default component.exports